<script lang="ts">
  import { onMount } from "svelte";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import { params } from "@roxi/routify";
  import { stagedRolloutCheck } from "@shared/svelte/Modules/StagedRolloutCheck.svelte";
  import { OpenProductGroupBannerEntity } from "@shared/services/event_tracking/entities";

  import { EventTracking } from "@shared/services/event_tracking/events";

  const { trackClick, trackMrcEvents } = EventTracking;

  let isOpenProductGroupPlp: boolean = false;
  let trackingParams;
  const getOpenGroupPlp = async () => {
    const res = await HttpPromise({
      method: "GET",
      url: "/api/retailer/limited_ordering_filters/open_product_groups",
    });

    const openProductGroup = res?.groups?.find(
      group => group.product_type_id === parseInt($params.type),
    );

    if (openProductGroup) {
      isOpenProductGroupPlp = true;
      trackingParams = [new OpenProductGroupBannerEntity(openProductGroup)];
    }
  };

  onMount(() => {
    if (stagedRolloutCheck("adm__dynamic_limited_ordering_filters") && $params.type) {
      getOpenGroupPlp();
    }
  });
</script>

{#if isOpenProductGroupPlp}
  <div
    class="fizz-alert-info"
    data-testid="open-product-group-banner"
    use:trackMrcEvents={[trackingParams]}
  >
    <div>
      <p><strong>Open product group</strong></p>
      <p
        >All products within this group have been approved for ordering by your corporate beverage
        team</p
      >
    </div>
    <div class="fizz--alert-links">
      <a
        class="fizz-button fizz-button-small"
        data-testid="open-product-group-banner-button"
        href="/lists"
        on:click={() => {
          trackClick("open_product_group_banner", trackingParams);
        }}>Back to order guide</a
      >
    </div>
  </div>
{/if}
